<template>
    <v-layout wrap mt-2>
        <v-flex xs12 sm6 lg4 pr-4>
            <ApolloQuery :query="require('../graphql/category/categories.gql')">
                <!-- The result will automatically updated -->
                <template slot-scope="{ result: { data, loading } }">
                    <v-autocomplete
                        class="mb-0"
                        :value="categories"
                        :items="data ? data.categories : []"
                        item-value="_id"
                        item-text="name"
                        :loading="loading"
                        @change="$emit('update:categories', $event)"
                        attach
                        solo
                        chips
                        clearable
                        :label="$t('label.categories')"
                        multiple
                    ></v-autocomplete>
                </template>
            </ApolloQuery>
        </v-flex>
        <v-flex xs12 sm6 lg4 pr-4>
            <ApolloQuery :query="require('../graphql/plan/plans.gql')">
                <template slot-scope="{ result: { data, loading } }">
                    <v-autocomplete
                        class="mb-0"
                        v-if="(data ? data.plans : []).length > 0 || loading"
                        :value="plan"
                        :items="data ? data.plans : []"
                        item-value="_id"
                        item-text="name"
                        @change="$emit('update:plan', $event)"
                        :loading="loading"
                        attach
                        solo
                        clearable
                        :label="$t('label.plans')"
                    ></v-autocomplete>
                </template>
            </ApolloQuery>
        </v-flex>
        <v-flex xs12 lg4 v-if="!hideStatus">
            <v-radio-group :value="status" row @change="$emit('update:status', $event)">
                <v-radio :label="$t('status.armed')" value="armed"></v-radio>
                <v-radio :label="$t('status.triggered')" value="triggered"></v-radio>
                <v-radio :label="$t('status.all')" value="all"></v-radio>
            </v-radio-group>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    props: {
        categories: {},
        plan: {},
        status: {},
        hideStatus: { type: Boolean, default: false },
    },
}
</script>
